import moment from 'moment';
import format from 'date-fns/format';

export const DATE_FORMATS = {
    sqlDate: 'YYYY-MM-DD HH:mm:ss',
    headingFormat: 'MMM DD',
    headingFormatNotThisYear: 'MMM DD YYYY',
    americanDate: 'MM/DD/YYYY',
    humanTime: 'HH:mm:ss',
    humanTimePartial: 'HH:mm',
    apiDateFormat: 'YYYY-MM-DD'
};

export const FORMATS = DATE_FORMATS
export const apiDateFormat = DATE_FORMATS.apiDateFormat

export default {
    toApiDateString: function (date) {
        if (!date) return format(new Date(), DATE_FORMATS.apiDateFormat);
        return format(date, DATE_FORMATS.apiDateFormat);
    },

    formatDateTimeAsDate: function (dateTime) {
        if (dateTime !== undefined) {
            return moment(dateTime, DATE_FORMATS.sqlDate)
                .format(DATE_FORMATS.americanDate)
            ;
        } else {
            return '';
        }
    },

    formatDateTimeAsTime: function (dateTime) {
        if (dateTime !== undefined) {
            return moment(dateTime, DATE_FORMATS.sqlDate)
                .format(DATE_FORMATS.humanTime)
            ;
        } else {
            return '';
        }
    },

    getHeadingDateFormat: function (startDateTime) {
        var now = moment();
        var momentDate = moment(startDateTime, DATE_FORMATS.sqlDate);
        var date = startDateTime.split(' ')[0],
            time = startDateTime.split(' ')[1];

        var final = '';

        if (momentDate.year() !== now.year()) {
            final += moment(momentDate).format(DATE_FORMATS.headingFormatNotThisYear);
        } else {
            final += moment(momentDate).format(DATE_FORMATS.headingFormat);
        }

        return final + ', ' + this.truncateSeconds(time);
    },

    truncateSeconds: function (time) {
        var momentDate = moment(time, DATE_FORMATS.humanTime);
        return moment(momentDate).format(DATE_FORMATS.humanTimePartial);
    },

    bytesToSize: function (bytes) {
        if (bytes) {
            if (parseInt(bytes, 10) === 0) return 'Could not Calculate';
            var k = 1000;
            var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
            var i = Math.floor(Math.log(bytes) / Math.log(k));
            return (bytes / Math.pow(k, i)).toPrecision(3) + ' ' + sizes[i];
        }
        return 'Not Available';
    },

    timecodeToSeconds: function (timecode) {
        if (typeof timecode !== 'string') return timecode

        var t = timecode.split(':'),
            seconds = -1;

        if (t.length == 2) {
            seconds = (+t[0]) * 60 * 60 + (+t[1]) * 60;
        } else if (t.length == 3) {
            seconds = (+t[0]) * 60 * 60 + (+t[1]) * 60 + (+t[2]);
        }

        if (seconds !== -1) {
            return seconds;
        }

        return null;
    },

    convertSecondsToHMS: function (seconds) {
        return moment().startOf('day').seconds(seconds).format('HH:mm:ss');
    },
    FORMATS: DATE_FORMATS
};
